.uploadWrapper :global(.ant-upload-list) {
  margin-top: 0;
  padding-top: 0;
}

.uploadWrapper :global(.ant-upload-list::before) {
  display: none;
}

.uploadWrapper :global(.ant-upload-list-item-container:first-child) {
  margin-top: 0;
}
